<mat-card class="mainclass">
  <div class="header">
    <div class="d-flex align-items-center">
      <div class="icon">
        <span class="material-symbols-outlined" style="cursor: default !important;"> group </span>
      </div>
      <div class="heading">Resources</div>
    </div>
    <span class="material-symbols-outlined audit_icon" (click)="resource_navigate()">
      settings
    </span>
  </div>
  <div class="table-container">
    <table>
      <tr>
        <td class="countvalue border-right">{{resourceWidgetData?.availableCount??0}}<br>
          <div class="textsize underline" style="cursor: pointer;" (click)="Available()">Talent Pool</div>
        </td>
        <td class="countvalue border-right">{{resourceWidgetData?.allocatedCount??0}} <br>
          <div class="textsize underline" style="cursor: pointer;" (click)="Blocked()"> Billable</div>
        </td>

        <td class="countvalue border-right">{{resourceWidgetData?.noticePeriodCount??0}}<br>
          <div class="textsize underline" style="cursor: pointer;" (click)="Noticeperiod()">Notice Period</div>
        </td>
        <td class="countvalue">{{resourceWidgetData?.totalCount??0}}<br>
          <div class="textsize underline" style="cursor: pointer;" (click)="Total()">Total</div>
        </td>
      </tr>
    </table>
  </div>
</mat-card>